import React from 'react'
import Layout from './../components/layout/index'
import pp from "../assets/pp2.png"

const sections = [
  {
    text: "Venture Intelligence respects your privacy and is committed to protecting the information shared with us through our website, databases, research products, newsletters, events, and related services."
  },
  {
    text: "Our market intelligence and transaction data are compiled through a combination of public disclosures, regulatory filings, company interactions, proprietary research, industry sources, and ongoing market tracking."
  },
  {
    heading: "Information We Collect",
    text: "We may collect information such as name, company details, designation, email address, contact information, subscription details, and website usage data to provide, improve, and manage our services and customer relationships. Such information may be shared with trusted service providers, partners, or regulatory authorities where necessary for operational, legal, or compliance purposes."
  },
  {
    heading: "Communications",
    text: "We may periodically send research updates, newsletters, event invitations, and service-related communications to registered users. Users may opt out of marketing communications at any time through the unsubscribe option included in such communications."
  },
  {
    heading: "Cookies & Analytics",
    text: "We may use cookies and analytics tools to enhance website functionality, understand usage patterns, and improve user experience."
  },
  {
    heading: "User Responsibilities",
    text: "Subscribers and users are responsible for maintaining the confidentiality of their account credentials and for all activities carried out through their accounts. Unauthorized use, reproduction, or redistribution of proprietary data, reports, or platform content without prior permission is prohibited."
  },
  {
    heading: "Security",
    text: "We implement reasonable security measures to protect information from unauthorized access, misuse, or disclosure. However, no digital platform can guarantee complete security."
  },
  {
    heading: "Third-Party Links",
    text: "Our website may contain links to external websites. Venture Intelligence is not responsible for the privacy practices or content of third-party sites."
  },
  {
    heading: "Policy Updates",
    text: "We may update this Privacy Policy from time to time to reflect changes in our services, regulatory requirements, or operational practices. Continued use of our services after such updates constitutes acceptance of the revised policy."
  },
  {
    heading: "Consent",
    text: "By accessing or using our services, you consent to the collection and use of information as described in this Privacy Policy."
  },
]

const PrivacyPolicy = () => {
  return (
    <Layout>
      {/* Hero Banner */}
      <div className="relative h-56 mb-12">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${pp})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 pb-16">
        <div className="space-y-6">
          {sections.map((section, index) => (
            <div key={index}>
              {/* {section.heading && (
                <h2 className="text-lg font-semibold text-[#a07924] mb-1">{section.heading}</h2>
              )} */}
              <p className="text-[#475569] text-base leading-relaxed">{section.text}</p>
            </div>
          ))}
        </div>

        {/* Contact */}
        <div className="mt-10 pt-6 border-t border-gray-200">
          <p className="text-[#475569] text-base leading-relaxed">
            For any privacy-related queries, please contact us at:{" "}
            <a
              href="mailto:info@ventureintelligence.com"
              className="text-[#a07924] font-medium hover:underline"
            >
              info@ventureintelligence.com
            </a>
          </p>
        </div>
      </div>
    </Layout>
  )
}

export default PrivacyPolicy